// import { withStyles, makeStyles } from '@mui/styles';
import React, { Component, useRef } from "react";
import Loader from "../../../../component/loader";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tabs,
  Tab,
  IconButton,
  FormHelperText,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Box,
  Select,
  Divider,
  FormControlLabel,
  FormLabel,
  MenuItem,
  RadioGroup,
  Radio,
} from "@mui/material";
import Input from "../../../../component/inputpm";
import Button from "../../../../component/button";
import Autocomplete from "@mui/material/Autocomplete";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
  ViewIconNew,
  OpenItemIcon,
  EndItemIcon,
  DeleteIconNew,
  AddItemIcon,
} from "../../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { TreeView, TreeItem } from "@mui/x-tree-view";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import CustomDropdown from "../../component/specification/customEnumDropdown.js";
import {
  toApi,
  fromApi,
  normalizeDateTime,
} from "../../component/specification/characteristicMapper";
import { withNavigation } from "../../../../helper/withNavigation.js";
import DraggableResizablePaper from "../../../../component/resizablePaper/resizablePaper";
import { formatNumber } from "../../../../helper/numberFormatter";

class ProductCharacteristics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      productCharacteristics: [],
      rowsPerPageCharacteristics: 20,
      pageCharacteristics: 1,
      startRecordCharacteristics: 1,
      totalCharacteristicsCount: 0,
      dialogOpenCharacteristics: false,
      actionType: "edit",
      characteristicDescription: "",
      name: "",
      tag: "",
      searchCategory: "",
      formDataCharacteristics: {
        id: "",
        name: "",
        description: "",
        valueType: "", //productFeatureTypeId
        specId: [], //productFeatureCategoryId
        value: "",
        enumerationValues: [],
        tag: "",
        format: "",
        externalId: "",
        sequenceNum: "",
        category: { id: "", name: "" },
      },
      characteristicsFormErrors: {
        name: false,
        description: false,
        valueType: false, //productFeatureTypeId
        specId: false, //productFeatureCategoryId
        value: false,
        sequenceNum: false,
      },

      productCharacteristicsTypes: [],
      allProductSpecifications: [],
      enumerationValues: [],

      selectedEnumValue: "",
      categoryList: [],
    };
  }

  decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };

  componentDidMount() {
    this.getCharacteristicList();
    this.getCharacteristicTypeList();
    this.getCategoryList();
  }

  handleEnumValueDropdownChange = (newValue) => {
    let isValid = this.validateFormat(
      newValue,
      this.state.formDataCharacteristics.format,
    );

    this.setState((prevState) => {
      // reset enumerationValues so only newValue is default
      const updatedEnumerationValues = (
        prevState.formDataCharacteristics.characteristicValueSpecification || []
      ).map((v) => ({
        ...v,
        isDefault: v.value === newValue,
      }));

      return {
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          value: isValid ? newValue : "",
          characteristicValueSpecification: updatedEnumerationValues,
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          value: !isValid,
        },
      };
    });
  };

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };

  handleCharacteristicError = (errorField, hasError) => {
    this.setState((prevState) => ({
      characteristicsFormErrors: {
        ...prevState.characteristicsFormErrors,
        [errorField]: hasError,
      },
    }));
  };

  handleDeleteEnumerationValue = (updatedValues) => {
    this.setState((prevState) => ({
      formDataCharacteristics: {
        ...prevState.formDataCharacteristics,
        characteristicValueSpecification: updatedValues,
      },
    }));
  };

  handleEnumerationChange = (updatedValues) => {
    console.log("updatedValues enum Value:", updatedValues);

    this.setState((prevState) => {
      // Ensure values exist and are an array
      const existingValues = Array.isArray(
        prevState.formDataCharacteristics.characteristicValueSpecification,
      )
        ? prevState.formDataCharacteristics.characteristicValueSpecification
        : [];

      // Merge new values without duplicates
      const uniqueValues = [
        ...existingValues,
        ...updatedValues.filter(
          (newVal) =>
            !existingValues.some((oldVal) => oldVal.value === newVal.value),
        ),
      ];

      // Reset all isDefault = false
      const resetValues = uniqueValues.map((v) => ({ ...v, isDefault: false }));

      // Mark the last added one as default
      if (updatedValues.length > 0) {
        const lastAdded = updatedValues[updatedValues.length - 1].value;
        const idx = resetValues.findIndex((v) => v.value === lastAdded);
        if (idx !== -1) {
          resetValues[idx].isDefault = true;
        }
      }

      console.log("enumerationValues final:", resetValues);

      return {
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          characteristicValueSpecification: resetValues, // unique + latest default
        },
      };
    });
  };

  getCharacteristicList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}${this.state.tag ? "&tag=" + this.state.tag : ""}${this.state.searchCategory && this.state.searchCategory != "-" ? "&category=" + this.state.searchCategory : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          const transformed = res.data.map(fromApi);
          this.setState({
            productCharacteristics: transformed,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getCharacteristicTypeList = () => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_PRODUCT_CHARACTERISTIC_TYPE/endpoint`,
      "",
    )
      .then((res) => {
        if (res.data?.types) {
          this.setState({ productCharacteristicsTypes: res.data.types });
        }
      })
      .catch((err) => {
        console.error(
          "Error fetching Product Characteristics value type:",
          err,
        );
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getCategoryList = () => {
    //this.setState({showLoading: true});
    const formData = { type: "PRODUCT_CHAR_CAT" };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PROD_SPEC_CHAR_CAT/endpoint`,
      formData,
    )
      .then((res) => {
        if (res.data?.categories) {
          const sortedCharCategoryList = [
            ...res.data.categories.sort((a, b) => a.name.localeCompare(b.name)),
          ];
          this.setState({ categoryList: sortedCharCategoryList });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics Category:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    //this.setState({showLoading: false});
  };

  goToProduct = () => {
    this.props.router.navigate("/products");
  };

  handleOpenDialogCharacteristics = (row, action) => {
    this.setState({
      dialogOpenCharacteristics: true,
      formDataCharacteristics: row,
      actionType: action,
      enumerationValues: [],
    });
  };

  handleCloseDialogCharacteristics = () => {
    this.setState({
      dialogOpenCharacteristics: false,
      characteristicsFormErrors: {},
      isCreatingNewEnum: false,
      newEnumValue: "",
    });
  };

  handleChangeCharacteristics = (event) => {
    const { name, value } = event.target;
    console.log(value, name);
    if (name === "category") {
      const selectedCategory = this.state.categoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          category: selectedCategory || { id: "", name: "" },
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          category: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else {
      let error = false;
      let updatedValue = value;
      let resetValue = this.state.formDataCharacteristics.value; // Preserve previous value

      if (name === "valueType") {
        resetValue = "";
      }
      if (name === "value" && value !== "") {
        /*const selectedType = this.state.formDataCharacteristics.type;
                if (selectedType === "NUMBER") {
                    error = !/^\d*$/.test(value); // Ensure only numeric input
                } else if (selectedType === "BOOLEAN") {
                    error = !["true", "false"].includes(value); // Ensure only true/false
                } else if (selectedType === "ENUMERATION") {
                    error = value.trim() === ""; // Ensure a valid selection
                }*/
      } else if (name === "valueType") {
        error = value === "-"; // Ensure a valid option is selected
      } else if (name === "name") {
        error = value.trim() === ""; // Ensure description is not empty
      } else if (name === "description") {
        error = value.trim() === ""; // Ensure description is not empty
      }
      this.setState((prevState) => ({
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          [name]: updatedValue, // Update the specific field
          ...(name === "valueType" && { value: resetValue }), // Reset value if valueType changes
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          [name]: error,
        },
      }));
    }
  };

  /* transformPayload(original) {
        // copy original so we don’t mutate directly
        const payload = { ...original };

        if (payload.value !== undefined) {
            payload.characteristicValueSpecification = [
              {
                isDefault: true,
                valueType: payload.valueType, // or map STRING→string, etc.
                value: payload.value,
              }
            ];
            delete payload.value; // remove old field
        }

        return payload;
    }*/

  handleSubmitCharacteristics = () => {
    const { value, valueType, name, description, id } =
      this.state.formDataCharacteristics;
    const specId = this.state.formDataCharacteristics.specId;

    const errors = {
      valueType: (valueType ?? "-") === "-",
      name: (name ?? "").trim() === "",
      description: (description ?? "").trim() === "",
    };

    const updatedFormData = {
      ...this.state.formDataCharacteristics,
      value:
        this.state.newEnumValue || this.state.formDataCharacteristics.value,
      enumerationValues: this.state.formDataCharacteristics.enumerationValues,
    };

    delete updatedFormData.specId;
    //console.log("--------updatedFormData-----",updatedFormData)
    this.setState(
      {
        formDataCharacteristics: updatedFormData,
        errors,
        characteristicsFormErrors: errors,
      },
      () => {
        // Proceed only if there are no validation errors
        if (!Object.values(errors).some((error) => error)) {
          this.setState({ showLoading: true });

          const apiMethod = id ? "PATCH" : "POST";
          const apiUrl = id
            ? `${constants.busV44UrlPublic}/productCharacteristics/${id}`
            : `${constants.busV44UrlPublic}/productCharacteristics`;

          const charName = name;
          const transformPayload = toApi(this.state.formDataCharacteristics);
          BusApiCall(apiMethod, apiUrl, transformPayload)
            .then((res) => {
              this.setState({ showLoading: false });
              if (res.data) {
                this.handleCloseDialogCharacteristics();
                this.getCharacteristicList();
                if (id) {
                  this.props.setErrorMessage(
                    this.props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY_NAME", {
                      charName,
                    }),
                    true,
                  );
                } else {
                  this.props.setErrorMessage(
                    this.props.t("CHARACTERISTIC_CREATED_SUCCESSFULLY_NAME", {
                      charName,
                    }),
                    true,
                  );
                }
              } else {
                console.error("Error in Product Characteristics API response");
              }
            })
            .catch((err) => {
              this.setState({ showLoading: false });
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              console.error("Error in Product Characteristics API:", err);
            });
        } else {
          console.error(
            "Validation errors detected, not proceeding with API call.",
          );
        }
      },
    );
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeSearchCategory = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  clearSearchCharacteristic = () => {
    this.setState(
      {
        characteristicDescription: "",
        name: "",
        tag: "",
        searchCategory: "",
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  onCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getCharacteristicList();
    }
  };

  handleChangePageCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageCharacteristics: newPage,
        startRecordCharacteristics:
          this.state.rowsPerPageCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageCharacteristics = (event) => {
    this.setState(
      {
        pageCharacteristics: 1,
        rowsPerPageCharacteristics: event.target.value,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  goToSpecification = () => {
    this.props.router.navigate("/specification");
  };

  selectCharacteristicDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-characteristic-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };

  BreadcrumbSection = () => {
    const { t } = this.props;
    return (
      <div className={"breadcrumbWrapper"}>
        <div className={"breadcrumbContent"}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <h3 className={"customBreadcrumb"}>
                <label>
                  <>
                    <u style={{ cursor: "pointer" }} onClick={this.goToProduct}>
                      {t("PRODUCTS")}
                    </u>{" "}
                    <span style={{ margin: "0 8px" }}>{">"}</span>{" "}
                    <b>{t("PRODUCT_CHARACTERISTICS")}</b>
                  </>
                </label>
              </h3>
            </Grid>
            <Grid
              item
              align="right"
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Button
                onClick={() => this.handleOpenDialogCharacteristics("")}
                style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
              >
                <span
                  style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                {t("NEW")} {t("PRODUCT_CHARACTERISTIC")}
              </Button>
              <Button
                className="buttonPrimary"
                onClick={this.goToSpecification}
                style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
              >
                {t("PRODUCT_SPECIFICATIONS")}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  };

  TableSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "15%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>
                  {t("VALUE")} {t("TYPE")}
                </b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>
                  {t("DEFAULT")} {t("VALUE")}
                </b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("TAGS")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("EXTERNAL_CODE")}</b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>{t("CATEGORY")}</b>
              </TableCell>
              <TableCell className="col-action" style={{ width: "10%" }}>
                <b>{t("ACTION")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.productCharacteristics.map((row, index) => (
              <TableRow key={row.id || `row-${index}`}>
                <TableCell>{row.name}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description}
                </TableCell>
                <TableCell>
                  <span style={{ textTransform: "capitalize" }}>
                    {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM"
                      ? "Enum"
                      : row.valueType.toLowerCase()}
                  </span>
                </TableCell>
                {/* <TableCell>{row.value}</TableCell> */}
                <TableCell>
                  {(row?.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM") &&
                  Array.isArray(row.characteristicValueSpecification)
                    ? (() => {
                        const defaultItem =
                          row.characteristicValueSpecification.find(
                            (item) => item.isDefault,
                          );
                        return defaultItem
                          ? `${defaultItem.id || ""} : ${defaultItem.value}`
                          : "";
                      })()
                    : row.value}
                </TableCell>

                <TableCell>{row.tag}</TableCell>
                <TableCell>{row.externalId}</TableCell>
                <TableCell>
                  {(() => {
                    const matchedCategory = this.state.categoryList.find(
                      (cat) => cat.id === row.category?.id,
                    );
                    return matchedCategory
                      ? matchedCategory.name
                      : row.category.name;
                  })()}
                </TableCell>
                <TableCell>
                  <Tooltip title={t("Edit")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={() =>
                        this.handleOpenDialogCharacteristics(row, "edit")
                      }
                      style={{ marginLeft: ".5rem" }}
                    >
                      <EditIconNew />
                    </IconButton>
                  </Tooltip>
                  &nbsp;
                  <Tooltip title={t("View")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={() =>
                        this.handleOpenDialogCharacteristics(row, "view")
                      }
                      style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                    >
                      <ViewIconNew />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {/*this.state.showLoading && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    {t('LOADING')}
                                </TableCell>
                            </TableRow>
                        )*/}
            {!this.state.showLoading &&
              this.state.productCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  PaginationCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageCharacteristics}
            onChange={this.handleChangeRowsPerPageCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalCharacteristicsCount /
              this.state.rowsPerPageCharacteristics,
          )}
          onChange={this.handleChangePageCharacteristics}
          page={this.state.pageCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  SearchSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.name}
            name={"name"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.characteristicDescription}
            name={"characteristicDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("TAGS")}
            value={this.state.tag}
            name={"tag"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel id="categoryLabelSearch" shrink>
              Category
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="searchCategory"
              value={this.state.searchCategory ?? ""}
              native
              label="Category"
              labelId="categoryLabelSearch"
              onChange={this.onChangeSearchCategory}
            >
              <option value="-">Select</option>
              {this.state.categoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getCharacteristicList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchCharacteristic}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  renderCategoryField = () => {
    return (
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <FormControl
          variant="outlined"
          size="small"
          className={classes.customeSelectLabel}
        >
          <InputLabel id="categoryLabel" style={{ background: "#fff" }} shrink>
            Category
          </InputLabel>
          <Select
            size="small"
            variant="outlined"
            name="category"
            value={this.state.formDataCharacteristics.category?.id ?? ""}
            native
            label="Category"
            labelId="categoryLabel"
            onChange={this.handleChangeCharacteristics}
            disabled={this.state.actionType === "view"}
          >
            <option value="-">Select</option>
            {this.state.categoryList.map((item) => (
              <option key={item.id} value={item.id}>
                {this.decodeHtml(item.name)}
              </option>
            ))}
          </Select>
        </FormControl>
      </Grid>
    );
  };

  renderExternalIdField = () => {
    return (
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Input
          size={"small"}
          variant={"outlined"}
          placeholder="External Code"
          name="externalId"
          divClass={classes.inputClass}
          value={
            this.state.actionType === "view" &&
            !this.state.formDataCharacteristics.externalId
              ? " "
              : (this.state.formDataCharacteristics.externalId ?? "")
          }
          onChange={this.handleChangeCharacteristics}
          disabled={this.state.actionType === "view"}
        />
      </Grid>
    );
  };

  renderAttributesFields = (t) => {
    return (
      <>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder="Tags"
            name="tag"
            divClass={classes.inputClass}
            value={
              this.state.actionType === "view" &&
              !this.state.formDataCharacteristics.tag
                ? " "
                : (this.state.formDataCharacteristics.tag ?? "")
            }
            onChange={this.handleChangeCharacteristics}
            disabled={this.state.actionType === "view"}
          />
        </Grid>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Input
            size="small"
            variant="outlined"
            placeholder="Sequence Number"
            name="sequenceNum"
            type="text"
            error={this.state.characteristicsFormErrors.sequenceNum}
            value={
              this.state.actionType === "view" &&
              !this.state.formDataCharacteristics.sequenceNum
                ? " "
                : (this.state.formDataCharacteristics.sequenceNum ?? "")
            }
            disabled={this.state.actionType === "view"}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                this.handleChangeCharacteristics(e);
              }
            }}
          />
          {this.state.characteristicsFormErrors.sequenceNum && (
            <p className="text-error" style={{ marginTop: "4px" }}>
              {this.state.characteristicsFormErrors.sequenceNum}
            </p>
          )}
        </Grid>
      </>
    );
  };
  renderInputField = () => {
    const { t } = this.props;
    const { valueType } = this.state.formDataCharacteristics;
    const { characteristicsFormErrors } = this.state;
    //console.log('-------------values-----',this.state.formDataCharacteristics);
    switch (valueType?.toUpperCase()) {
      case "BOOLEAN":
        return (
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
            error={this.state.characteristicsFormErrors.value}
            fullWidth
          >
            <InputLabel
              id="booleanValueLabel"
              style={{ background: "#fff" }}
              shrink
            >
              Default Value
            </InputLabel>
            <Select
              labelId="booleanValueLabel"
              size="small"
              variant="outlined"
              name="value"
              error={this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              onChange={this.handleChangeCharacteristics}
              native
              label="Value"
              disabled={this.state.actionType === "view"}
            >
              <option value="-">Select</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </Select>
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                Please select a valid value.
              </p>
            )}
          </FormControl>
        );

      case "NUMBER":
        return (
          <>
            {/* <Input
                        size="small"
                        variant="outlined"
                        placeholder="Default Value"
                        name="value"
                        type="text"
                        value={this.state.formDataCharacteristics.value||''}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                                this.handleChangeCharacteristics(e);
                            }
                        }}
                        onBlur={(e) => {
                            const value = e.target.value;
                            this.setState((prevState) => ({
                                characteristicsFormErrors: {
                                    ...prevState.characteristicsFormErrors,
                                    value: value.trim() === "" || isNaN(value) ? "Value must be numeric." : "",
                                },
                            }));
                        }}
                    />
                    {this.state.characteristicsFormErrors.value && (
                      <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                          Value must be numeric.
                      </p>
                    )} */}
            <Input
              size="small"
              variant="outlined"
              placeholder="Default Value"
              name="value"
              type="text"
              error={this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;

                // Allow the user to type freely
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                } else {
                  this.setState((prevState) => ({
                    formDataCharacteristics: {
                      ...prevState.formDataCharacteristics,
                      value: isNaN(value) ? "" : value,
                    },
                    characteristicsFormErrors: {
                      ...prevState.characteristicsFormErrors,
                      value: isNaN(value) ? "Value must be numeric." : "",
                    },
                  }));
                }
              }}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );

      case "DECIMAL":
        return (
          <>
            {/*<Input
                            size="small"
                            variant="outlined"
                            placeholder="Default Value"
                            name="value"
                            type="text"
                            value={this.state.formDataCharacteristics.value||''}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only decimal numbers
                                if (/^\d*\.?\d*$/.test(value)) {
                                    this.handleChangeCharacteristics(e);
                                }
                            }}
                            onBlur={(e) => {
                                const value = e.target.value;
                                this.setState((prevState) => ({
                                    characteristicsFormErrors: {
                                        ...prevState.characteristicsFormErrors,
                                        value: value.trim() === "" || isNaN(value) ? "Value must be a valid decimal number." : "",
                                    },
                                }));
                            }}
                        /> */}
            <Input
              size="small"
              variant="outlined"
              placeholder="Default Value"
              name="value"
              type="text"
              error={this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;

                // Allow the user to type freely
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                } else {
                  this.setState((prevState) => ({
                    formDataCharacteristics: {
                      ...prevState.formDataCharacteristics,
                      value: isNaN(value) ? "" : value,
                    },
                    characteristicsFormErrors: {
                      ...prevState.characteristicsFormErrors,
                      value: isNaN(value)
                        ? "Value must be a valid decimal number."
                        : "",
                    },
                  }));
                }
              }}
            />

            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );

      case "DATETIME":
        return (
          <>
            <FormControl
              variant="outlined"
              size="small"
              error={!!this.state.characteristicsFormErrors.value}
              className={classes.customeSelectLabel}
              fullWidth
            >
              <InputLabel
                id="dateTimeValueLabel"
                style={{ background: "#fff" }}
                shrink
              >
                DD-MM-YYYY HH:MM{" "}
              </InputLabel>
              <Input
                size="small"
                variant="outlined"
                //placeholder="YYYY-MM-DD HH:MM:SS"
                name="value"
                labelId="dateTimeValueLabel"
                type="datetime-local"
                //error={this.state.characteristicsFormErrors.value}
                //value={this.state.formDataCharacteristics.value || ''}
                value={normalizeDateTime(
                  this.state.formDataCharacteristics.value,
                )}
                disabled={this.state.actionType === "view"}
                onChange={this.handleChangeCharacteristics}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Validate datetime format (YYYY-MM-DDTHH:MM)
                  if (!value) {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "Please enter a valid date and time.",
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "",
                      },
                    }));
                  }
                }}
              />
            </FormControl>
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );

      case "DATE":
        return (
          <>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              error={!!this.state.characteristicsFormErrors.value}
            >
              <InputLabel
                id="dateValueLabel"
                style={{ background: "#fff" }}
                shrink
              >
                DD-MM-YYYY
              </InputLabel>
              <Input
                size="small"
                variant="outlined"
                //placeholder="YYYY-MM-DD"
                name="value"
                type="date"
                labelId="dateValueLabel"
                //error={this.state.characteristicsFormErrors.value}
                value={this.state.formDataCharacteristics.value ?? ""}
                disabled={this.state.actionType === "view"}
                onChange={this.handleChangeCharacteristics}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Validate date format
                  if (!value) {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "Please enter a valid date.",
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "",
                      },
                    }));
                  }
                }}
              />
              {this.state.characteristicsFormErrors.value && (
                <p className="text-error" style={{ marginTop: "4px" }}>
                  {this.state.characteristicsFormErrors.value}
                </p>
              )}
            </FormControl>
          </>
        );

      case "ENUMERATION":
      case "ENUM":
        return (
          <div>
            {/*<CustomDropdown onEnumerationChange={this.handleEnumerationChange} onSelectChange={this.handleEnumValueDropdownChange} options={this.state.formDataCharacteristics.enumerationValues} defaultValue={this.state.formDataCharacteristics.value} actionType={this.state.actionType}/>*/}
            <CustomDropdown
              onEnumerationChange={this.handleEnumerationChange}
              onDeleteEnumerationValue={this.handleDeleteEnumerationValue}
              onErrorChange={this.handleCharacteristicError}
              onSelectChange={this.handleEnumValueDropdownChange}
              options={
                this.state.formDataCharacteristics
                  .characteristicValueSpecification
              }
              defaultValue={
                this.state.formDataCharacteristics
                  .characteristicValueSpecification &&
                this.state.formDataCharacteristics.characteristicValueSpecification.find(
                  (v) => v.isDefault,
                )?.value
              }
              formatValue={this.state.formDataCharacteristics.format}
              actionType={this.state.actionType}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                Invalid value. Allowed:{" "}
                {this.state.formDataCharacteristics.format.replace(/\|/g, ", ")}
                {/*Value does not match the {t("VALIDATION_FORMAT")}:- {this.state.formDataCharacteristics.format}*/}
              </p>
            )}
          </div>
        );
      default:
        return (
          <>
            <Input
              size="small"
              variant="outlined"
              placeholder="Default Value"
              name="value"
              type="text"
              labelId="stringValueLabel"
              error={this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                }
              }}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );
    }
  };

  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <Loader loading={this.state.showLoading} />
        {this.BreadcrumbSection()}
        <main style={{ position: "relative" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {!this.state.showLoading && (
              <>
                <div style={{ marginBottom: ".5rem" }}>
                  {this.SearchSectionCharacteristic()}
                </div>
                <Card
                  variant="outlined"
                  style={{ borderRadius: "8px", marginBottom: "40px" }}
                >
                  {this.TableSectionCharacteristic()}
                  {this.state.totalCharacteristicsCount >
                    this.state.rowsPerPageCharacteristics &&
                    this.PaginationCharacteristic()}
                </Card>
              </>
            )}
          </div>
        </main>
        <Dialog
          open={this.state.dialogOpenCharacteristics}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          // PaperComponent={this.selectCharacteristicDialog}
          PaperComponent={DraggableResizablePaper}
          aria-labelledby="select-characteristic-dialog"
          // PaperProps={{ className: jssClasses.resizablePaper }}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogCharacteristics();
            }
          }}
        >
          {!this.state.formDataCharacteristics.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-characteristic-dialog"
            >
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {this.state.actionType !== "view" ? "Create" : ""}{" "}
                  Characteristic Specification
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) =>
                      this.handleCloseDialogCharacteristics()
                    }
                    onClick={(event) => this.handleCloseDialogCharacteristics()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
          )}
          {this.state.formDataCharacteristics.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-characteristic-dialog"
            >
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {this.state.actionType !== "view" ? "Update" : "View"}{" "}
                  Characteristic Specification
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) =>
                      this.handleCloseDialogCharacteristics()
                    }
                    onClick={(event) => this.handleCloseDialogCharacteristics()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
          )}
          <DialogContent
            dividers
            style={{ paddingLeft: "30px", paddingRight: "30px" }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                style={{ padding: "1rem" }}
                size={{
                  xs: 12,
                }}
              >
                <Grid container spacing={2}>
                  {this.state.formDataCharacteristics.id && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <Input
                          name="id"
                          placeholder={t("ID")}
                          variant={"outlined"}
                          divClass={classes.customDiv}
                          size={"small"}
                          style={{ width: "98%" }}
                          value={this.state.formDataCharacteristics.id}
                          onChange={this.handleChangeCharacteristics}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                  )}
                  {this.renderCategoryField()}
                  {this.renderExternalIdField()}
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder="Name *"
                      name="name"
                      divClass={classes.inputClass}
                      value={this.state.formDataCharacteristics.name ?? ""}
                      onChange={this.handleChangeCharacteristics}
                      disabled={this.state.actionType === "view"}
                      error={this.state.characteristicsFormErrors.name}
                    />
                    {this.state.characteristicsFormErrors.name && (
                      <p
                      className="text-error"
                        style={{
                          marginTop: "4px",
                        }}
                      >
                        Name is required.
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder="Description *"
                      name="description"
                      divClass={classes.inputClass}
                      value={
                        this.state.formDataCharacteristics.description ?? ""
                      }
                      onChange={this.handleChangeCharacteristics}
                      disabled={this.state.actionType === "view"}
                      error={this.state.characteristicsFormErrors.description}
                      inputProps={{ maxLength: 255 }}
                      multiline
                    />
                    {this.state.characteristicsFormErrors.description && (
                      <p
                      className="text-error"
                        style={{
                          marginTop: "4px",
                        }}
                      >
                        Description is required.
                      </p>
                    )}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size={"small"}
                      className={classes.customeSelectLabel}
                      error={this.state.characteristicsFormErrors.valueType}
                    >
                      <InputLabel
                        id="characteristicTypeLabel"
                        style={{ background: "#fff" }}
                        shrink
                      >
                        Value Type *
                      </InputLabel>
                      <Select
                        size={"small"}
                        variant={"outlined"}
                        name="valueType"
                        value={this.state.formDataCharacteristics.valueType?.toUpperCase()}
                        native
                        label="Value Type *"
                        labelId="characteristicTypeLabel"
                        onChange={this.handleChangeCharacteristics}
                        disabled={this.state.actionType === "view"}
                      >
                        <option value="-">Select</option>
                        {this.state.productCharacteristicsTypes
                          .filter(
                            (option) =>
                              option.typeId !== "PRD_CHARS" &&
                              option.typeId !== "OBJECT",
                          )
                          .map((option) => {
                            // Normalize ENUM / ENUMERATION to one value for UI
                            const normalizedTypeId =
                              option.typeId?.toUpperCase() === "ENUMERATION"
                                ? "ENUM"
                                : option.typeId?.toUpperCase();

                            return (
                              <option
                                key={option.typeId}
                                value={normalizedTypeId}
                              >
                                {option.name}
                              </option>
                            );
                          })}
                      </Select>
                      {this.state.characteristicsFormErrors.valueType && (
                        <p
                          className="text-error"
                          style={{
                            marginTop: "4px",
                          }}
                        >
                          Please select a valid characteristic value type.
                        </p>
                      )}
                    </FormControl>
                  </Grid>
                  {/*this.state.formDataCharacteristics.id && (
                                            <Grid item xs={12} md={6}>&nbsp;</Grid>
                                        )*/}
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("VALIDATION_FORMAT")}
                      name="format"
                      divClass={classes.inputClass}
                      value={
                        this.state.actionType === "view" &&
                        !this.state.formDataCharacteristics.format
                          ? " "
                          : (this.state.formDataCharacteristics.format ?? "")
                      }
                      onChange={this.handleChangeCharacteristics}
                      disabled={this.state.actionType === "view"}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    {this.renderInputField()}
                  </Grid>
                  {this.renderAttributesFields(t)}

                  {this.state.formDataCharacteristics.id &&
                    this.state.actionType !== "view" && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <p
                          style={{
                            color: "#f44336",
                            position: "absolute",
                            bottom: 0,
                          }}
                        >
                          {t("CHANGE_CHARACTERISTIC_IMPACT")}
                        </p>
                      </Grid>
                    )}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            {/*<Button onClick={this.handleCloseDialogCharacteristics} className='button buttonSecondary'>
                            Cancel
                        </Button>*/}
            {!this.state.formDataCharacteristics.id &&
              this.state.actionType !== "view" && (
                <Button
                  variant="contained"
                  className="button"
                  onClick={this.handleSubmitCharacteristics}
                >
                  Create
                </Button>
              )}
            {this.state.formDataCharacteristics.id &&
              this.state.actionType !== "view" && (
                <Button
                  variant="contained"
                  className="button"
                  onClick={this.handleSubmitCharacteristics}
                >
                  Update
                </Button>
              )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '65vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ProductCharacteristics)));
